export default "__VITE_ASSET__aaQcwFI$__"